import React, {HTMLAttributes, ReactNode} from "react";
import {DrawerProps} from "../drawer/drawer.style";

export type selectTriggerSize = "md" | "lg";
export type selectTriggerVariant = "standard" | "outlined" | "static";

export interface selectTriggerStyleProps {
    $size?: selectTriggerSize
    $variant?: selectTriggerVariant
}

export type OptionWrapperStyleProps = {
    $fitToScreenOnMobile?: boolean
}

export type offset = number;
export type OptionComponentProps = {
    children: string | ReactNode;
    value?: string;
    offset?: number;
    portal?: boolean;
    className?: string;
    arrow?: boolean;
    icon?: ReactNode
}
export type SelectComponentProps = HTMLAttributes<HTMLButtonElement> & {
    variant?: selectTriggerVariant;
    size?: selectTriggerSize;
    offset?: offset;
    label?: string;
    children: React.ReactNode;
    error?: boolean;
    success?: boolean;
    message?: string;
    arrow?: ReactNode;
    selected?: string | string[] | null;
    disabled?: boolean;
    multiple?: boolean;
    onOpenChange?: (open: boolean) => void;
    onSelectionChange?: (value: string | string[], selectedDisplayValues: (string)[]) => void;
    fitToScreenOnMobile?: boolean;
    placeholder?: string;
    defaultValue?: string | string[];
    wrapperProps?: HTMLAttributes<HTMLDivElement>;
    drawerProps?: Partial<DrawerProps>;
}
export type valueContent = Record<string, {
    displayValue: (string | ReactNode)[];
    value?: string;
}>
export const SelectComponentContext = React.createContext<{
    componentId: string;
    handleSelect: (val: string, children: string, id?: string) => void;
    activeId: string | null | string[];
    multiple: boolean;
} | null>(null);